/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { useArg } from 'solis/navigation';

import { CreateInfluence } from 'solis/claude/action';
import useBoardContext from 'solis/claude/action/context/board';
import descriptor from 'solis/claude/action/descriptor/create.influence';

import SectorCard from 'solis/claude/card/sector';
import ZoneInfo from 'solis/claude/card/zone';
import SourceColony from 'solis/claude/card/source.colony';

import ZoneTimeline from 'solis/logic/board/zone/timeline';


const getExistingValue = ({ zone, sourceColony }) =>
{
  return zone.getInfluence(sourceColony.cass.id)?.cass.value ?? 0;
};


const getInfluenceDelta = (context, value) =>
{
  return descriptor.isAvailable(context) ? value - getExistingValue(context) : 0;
};


const getZoneTimeline = (context, originalTimeline, value) =>
{
  if (!descriptor.isAvailable(context) || value === getExistingValue(context))
  {
    return originalTimeline;
  }

  return ZoneTimeline.createWithInfluence(context.zone, context.now, context.sourceColony.cass.id, value);
};


export default () =>
{
  const context = useBoardContext();

  const value = useArg('value', descriptor.scope) ?? descriptor.inputs.value;

  const { board, zone } = context;

  const originalTimeline = zone !== null ? ZoneTimeline.create(zone) : null;

  const zoneTimeline = getZoneTimeline(context, originalTimeline, value);

  return (
    <Flex direction = 'column' gap = '4' p = '4'>

      <SourceColony context = {context} influenceDelta = {getInfluenceDelta(context, value)} />

      <CreateInfluence context = {context} />

      {zone !== null && <SectorCard sector = {zone.getSector()} />}
      {zone !== null && <ZoneInfo key = {zone.getAbsoluteHex() + ':' + value} board = {board} zone = {zone} zoneTimeline = {zoneTimeline} originalTimeline = {originalTimeline} />}

    </Flex>
  );
};
